import ProductsCategoriesRegistration from './ProductsCategoriesRegistration';

export default ProductsCategoriesRegistration;